// "use strict";
Object.defineProperty(exports, "__esModule", {
  value: true,
});
if (process.env.NODE_ENV === "development") {
  exports.default = {
    panelURL: "https://localhost:3001/",
    // baseURL: "https://flipshope.com/api",
    imageURL: "https://cdn.alladdinx.com/",
    baseURL: "http://localhost:3000/api",
    backendURL: "http://localhost:8080/api",
  };
} else {
  exports.default = {
    websiteURL: "https://team.alladdinx.com/",
    baseURL: "https://team.alladdinx.com/api",
    imageURL: "https://cdn.alladdinx.com/",
    // baseURL: "http://localhost:3000/api",
    backendURL: "https://team.alladdinx.com/api",
  };
}
